import EllipsesHorizontalIconPath from "@ingka/ssr-icon/paths/ellipses-horizontal";

export default EllipsesHorizontalIconPath;
